import React, { createContext, useContext, useReducer } from 'react';

const FavoriteEventsContext = createContext();
const FavoriteEventsDispatchContext = createContext();

export function useFavoriteEvents() {
    return useContext(FavoriteEventsContext);
}

export function useFavoriteEventsDispatch() {
    return useContext(FavoriteEventsDispatchContext);
}

export function getFavoriteEventsFromLS(key) {
    const saved = localStorage.getItem(key);
    if (saved == null) {
        return {};
    } else {
        const favorites = JSON.parse(saved);

        let maxTs = new Date();
        maxTs.setMinutes(maxTs.getHours() - 12);
        maxTs = +maxTs;
        const toDelete = new Set();
        Object.keys(favorites).forEach(key => {
            const ts = favorites[key]
            if (ts < maxTs) {
                toDelete.add(key);
            }
        });

        if (toDelete.size > 0) {
            toDelete.forEach(id => delete favorites[id]);
        }

        return favorites;
    }
}

function saveFavoriteEventsToLS(key, favorites) {
    if (Object.values(favorites).length > 0) {
        localStorage.setItem(key, JSON.stringify(favorites));
    } else {
        localStorage.removeItem(key);
    }
}

function favoritesReducer(favorites, action) {
    switch (action.type) {
        case 'toggle': {
            if (favorites[action.id] == null) {
                favorites[action.id] = +new Date();
            } else {
                delete favorites[action.id];
            }
            saveFavoriteEventsToLS('xs_favorite_events', favorites);
            return {...favorites};
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

export default function FavoriteEventsProvider(props) {
    const [favorites, dispatch] = useReducer(
        favoritesReducer,
        getFavoriteEventsFromLS('xs_favorite_events')
    );

    return (
        <FavoriteEventsContext.Provider value={favorites}>
            <FavoriteEventsDispatchContext.Provider value={dispatch}>
                {props.children}
            </FavoriteEventsDispatchContext.Provider>
        </FavoriteEventsContext.Provider>
    );
}
